export default __webpack_public_path__ + "static/noImage-79d89834826bc722ea1d0099b0e790b0.png";